import React from "react";
import { FaArrowRight } from "react-icons/fa";

const steps = [
  {
    number: "1",
    title: "Step 1",
    desc: "Customer Booking Service ",
  },
  {
    number: "2",
    title: "Step 2",
    desc: "System Matches with nearest Worker/Supplier ",
  },
  {
    number: "3",
    title: "Step 3",
    desc: "Job Completed & Customer Pays",
  },
  {
    number: "4",
    title: "Step 4",
    desc: "Commission Deducted & Weekly Payout to Worker ",
  },
  {
    number: "5",
    title: "Step 5",
    desc: "Feedback Updates Worker's Profile Rating",
  },
];

const Workflow = () => {
  return (
    <section className="workflow-clean">
      <div className="container">
        <div className="text-center mb-5">
          <h6 className="small-title">HOW IT WORKS</h6>
          <h2 className="main-title">Simple 5 Step Process</h2>
        </div>

        <div className="steps">
          {steps.map((step) => (
            <>
              <div className="workflow-card">
                <div className="step-badge">{step.number}</div>
                <h5>{step.title}</h5>
                <p>{step.desc}</p>
              </div>
              <FaArrowRight />
            </>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Workflow;
